var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#69A401;} .st1{fill:#EFE691;} .st2{fill:#B20000;} .st3{fill:#DF1801;} .st4{fill:#F40603;} .st5{fill:#FFEEEE;} .st6{fill:#847B3C;} .st7{fill:#CEB600;} .st8{fill:#F8CD02;} .st9{fill:#F7C800;} .st10{fill:#F6E8B9;} .st11{fill:#F6E9CA;} .st12{fill:#CF8A11;} .st13{fill:#286F0D;} .st14{fill:#63271D;} .st15{fill:#EB8102;} .st16{fill:#E37303;} .st17{fill:#D97102;} .st18{fill:#BF6302;} .st19{fill:#EA9735;} .st20{fill:#3E1A01;} .st21{fill:#C96A0A;} .st22{fill:#CE2335;} .st23{fill:#C0242D;} .st24{fill:#BA1A23;} .st25{fill:#F9DCC7;} .st26{fill:#DBE2CE;} .st27{fill:#7D4B12;} .st28{fill:#75480C;} .st29{fill:#66410C;} .st30{fill:#88550D;} .st31{fill:#FFFEE9;} .st32{fill:#9B9F1A;} .st33{fill:#F6E177;} .st34{fill:#443A00;} .st35{fill:#305209;} .st36{fill:#7F7C04;} .st37{fill:#BAB424;} .st38{fill:#F7CF43;} .st39{fill:#DE940E;} .st40{fill:#5F570A;} .st41{fill:#175424;} .st42{fill:#215B25;} .st43{fill:#1B5020;} .st44{fill:#C0F9C0;} .st45{fill:#F3DA78;} .st46{fill:#BC441C;} .st47{fill:#148E2E;} .st48{fill:#283767;} .st49{fill:#425285;} .st50{fill:#CFDFFF;} .st51{fill:#1F2C55;} .st52{fill:#776220;} .st53{fill:#90236B;} .st54{fill:#5D1A47;} .st55{fill:#99499A;} .st56{fill:#FCCAFA;} .st57{fill:#917C31;} .st58{fill:#F4C435;} .st59{fill:#F1BC02;} .st60{fill:#F0B102;} .st61{fill:#F1F7BA;} .st62{fill:#E3DCB9;} .st63{fill:#BD6800;} .st64{fill:#E19704;} .st65{fill:#B2CA2B;} .st66{fill:#AFC20F;} .st67{fill:#B9CB00;} .st68{fill:#E5F392;} .st69{fill:#F78202;} .st70{fill:#F79613;} .st71{fill:#331F07;} .st72{fill:#402B16;} .st73{fill:#669404;} .st74{fill:#F58E13;} .st75{fill:#D87117;} .st76{fill:#216604;} .st77{fill:#286D08;} .st78{fill:#C8C625;} .st79{fill:#2C441F;} .st80{fill:#F1E6BF;} .st81{fill:#F2BE2E;} .st82{fill:#BF8F33;} .st83{fill:#568804;} .st84{fill:#669614;} .st85{fill:#688E0C;} .st86{fill:#4C7005;} .st87{fill:#A0CA49;} .st88{fill:#99BD70;} .st89{fill:#78AA25;} .st90{fill:#4B7C23;} .st91{fill:#EADBC8;} .st92{fill:#F0D5B0;} .st93{fill:#DF2B2B;} .st94{fill:#D1262C;} .st95{fill:#B7252C;} .st96{fill:#46670C;} .st97{fill:#F49D5B;} .st98{fill:#F57A55;} .st99{fill:#F1C3A7;} .st100{fill:#CC0917;} .st101{fill:#DC1035;} .st102{fill:#9BAC0F;} .st103{fill:#667A1D;} .st104{fill:#7A9D18;} .st105{fill:#F6F7E6;} .st106{fill:#F0194D;} .st107{fill:#362420;} .st108{fill:#530618;} .st109{fill:#44041A;} .st110{fill:#490419;} .st111{fill:#F8A459;} .st112{fill:#871B22;} .st113{fill:#600613;} .st114{fill:#F8C790;} .st115{fill:#447832;} .st116{fill:#7C473D;} .st117{fill:#441432;} .st118{fill:#51163F;} .st119{fill:#5B1A41;} .st120{fill:#FCEBF9;} .st121{fill:#ECE5CE;} .st122{fill:#BC3E2C;} .st123{fill:#A60F26;} .st124{fill:#C61632;} .st125{fill:#BD1331;} .st126{fill:#F8B772;} .st127{fill:#F7DDAC;} .st128{fill:#850E11;} .st129{fill:#191200;} .st130{fill:#553D2D;} .st131{fill:#F9E2D2;} .st132{fill:#CA8937;} .st133{fill:#462D16;} .st134{fill:#6D8916;} .st135{fill:#96B54E;} .st136{fill:#E3E2DE;} .st137{fill:#261811;} .st138{fill:#525C11;} .st139{fill:#14581E;} .st140{fill:#3D7712;} .st141{fill:#9BC148;} .st142{fill:#E22434;} .st143{fill:#C6DD9E;} .st144{fill:#F89A07;} .st145{fill:#F7A410;} .st146{fill:#F8AB19;} .st147{fill:#F7B81C;} .st148{fill:#E5870A;} .st149{fill:#97A304;} .st150{fill:#A88C5C;} .st151{fill:#ADC21E;} .st152{fill:#A3BA0B;} .st153{fill:#8D9E08;} .st154{fill:#E0DAB9;} .st155{fill:#684219;} .st156{fill:#777F05;} .st157{fill:#F2E9C4;} .st158{fill:#CBB465;} .st159{fill:#FFF5CA;} .st160{fill:#E52828;} .st161{fill:#F87302;} .st162{fill:#FF7B22;} .st163{fill:#FC7F10;} .st164{fill:#F8A200;} .st165{fill:#F8DC91;} .st166{fill:#FFFFFF;} .st167{fill:#F5D7D5;} .st168{fill:#EDA07A;} .st169{fill:#FCBEBE;} .st170{fill:#EAD991;} .st171{fill:#582612;} "), /*#__PURE__*/React.createElement("g", {
    id: "_x33_0_Mulberry"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x32_9_Star_Fruit"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x32_8_Apricot"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x32_7_Litchi"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x32_6_Kiwi"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x32_5_Jackfruit"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x32_4_Avacado"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x32_3_Blueberry"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x32_2_Purple_Grapes"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x32_1_Melon"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x32_0_Green_Grapes"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_9_Papaya"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_8_Pineapple"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_7_Banana"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_6_Tender_Coconut"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_5_Strawberry"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_4_Dragon_Fruit"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_3_Plum"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_2_Fig"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_1_Peach"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_710_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_730_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_731_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M45.183,11.223c-3.357,5.226-3.77,11.334-1.703,16.649 c5.988-0.788,11.559-3.997,14.916-9.223C61.753,13.423,62.166,7.315,60.099,2C54.111,2.788,48.54,5.997,45.183,11.223z",
    id: "XMLID_733_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M43.931,36.342c-1.104,0-2-0.896-2-2v-2.594c0-4.864-2.416-9.352-6.461-12.007 c-0.923-0.606-1.181-1.846-0.575-2.77c0.606-0.924,1.845-1.181,2.77-0.575c5.177,3.397,8.267,9.136,8.267,15.352v2.594 C45.931,35.446,45.036,36.342,43.931,36.342z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M56.048,107.476c10.097-2.316,22.099-15.179,25.973-28.413 c3.262-10.394,2.978-19.246,1.727-25.764c-2.365-12.319-12.479-21.778-24.756-22.34c-0.435-0.02-0.872-0.03-1.311-0.03 c-4.47,0-8.693,1.048-12.451,2.903c-0.776,0.383-1.685,0.383-2.461,0c-3.758-1.855-7.981-2.903-12.451-2.903 C14.678,30.929,2,42.18,2,59.398C2,83.177,15.729,116.726,56.048,107.476z",
    id: "XMLID_737_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.35,82.47c-0.13,0-0.26-0.01-0.39-0.04c-0.13-0.02-0.25-0.06-0.37-0.11c-0.13-0.05-0.24-0.11-0.35-0.18 c-0.11-0.08-0.21-0.16-0.3-0.25c-0.38-0.38-0.59-0.89-0.59-1.42c0-0.52,0.21-1.04,0.59-1.41c0.46-0.47,1.15-0.68,1.8-0.55 c0.13,0.03,0.26,0.07,0.38,0.12c0.12,0.05,0.23,0.11,0.34,0.18c0.11,0.07,0.21,0.16,0.31,0.25c0.37,0.37,0.58,0.89,0.58,1.41 c0,0.53-0.21,1.04-0.58,1.42c-0.1,0.09-0.2,0.17-0.31,0.25c-0.11,0.07-0.22,0.13-0.34,0.18c-0.12,0.05-0.25,0.09-0.38,0.11 C19.61,82.46,19.48,82.47,19.35,82.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M22.667,59.398c0-13.091,7.333-22.727,17.721-26.597c-3.13-1.202-6.52-1.872-10.071-1.872 C14.678,30.929,2,42.18,2,59.398c0,23.346,13.236,56.104,51.872,48.538C31.031,102.467,22.667,77.957,22.667,59.398z",
    id: "XMLID_434_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M12.333,59.398c0-15.219,9.909-25.771,23.01-28.016c-1.631-0.295-3.31-0.453-5.026-0.453 C14.678,30.929,2,42.18,2,59.398c0,22.192,11.961,52.886,46.328,49.369C21.858,105.773,12.333,79.2,12.333,59.398z",
    id: "XMLID_438_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M15.942,76c-0.913,0-1.737-0.629-1.948-1.556c-1.114-4.893-1.704-10.096-1.704-15.046 c0-3.165,0.408-6.226,1.213-9.098c0.298-1.063,1.401-1.687,2.466-1.386c1.063,0.298,1.684,1.402,1.386,2.466 c-0.707,2.52-1.065,5.218-1.065,8.018c0,4.656,0.555,9.552,1.604,14.158c0.245,1.077-0.429,2.149-1.506,2.395 C16.239,75.983,16.09,76,15.942,76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M47.091,70.675c0.4,0.381,0.913,0.571,1.425,0.571c0.545,0,1.09-0.214,1.497-0.641 c0.788-0.826,0.756-2.134-0.07-2.922c-0.699-0.666-16.957-16.5-3.149-32.501c0.539-0.625,0.632-1.478,0.319-2.186 c-0.638,0.259-1.269,0.532-1.884,0.836c-0.776,0.383-1.685,0.383-2.461,0c-0.046-0.023-0.093-0.042-0.139-0.064 C28.214,52.278,46.896,70.489,47.091,70.675z",
    id: "XMLID_526_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_711_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M101.767,124.654c8.563-1.981,18.742-12.982,22.027-24.3 c2.767-8.889,2.526-16.46,1.464-22.035c-2.006-10.536-10.583-18.626-20.995-19.107c-0.368-0.017-0.739-0.026-1.112-0.026 c-3.791,0-7.372,0.896-10.56,2.483c-0.658,0.328-1.429,0.328-2.087,0c-3.187-1.587-6.769-2.483-10.56-2.483 c-13.263,0-24.62,9.635-24.015,24.348C56.767,103.889,67.574,132.564,101.767,124.654z",
    id: "XMLID_729_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M123.795,96.22c-3.286,11.319-13.464,22.319-22.027,24.3 c-32.882,7.607-44.904-18.631-45.779-38.741c-0.035,0.577-0.058,1.16-0.058,1.755c0,20.337,11.644,49.03,45.837,41.12 c8.563-1.981,18.742-12.982,22.027-24.3c1.892-6.079,2.376-11.54,2.155-16.169C125.781,87.828,125.15,91.864,123.795,96.22z",
    id: "XMLID_32_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_712_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st128",
    cx: 90.965,
    cy: 90.526,
    id: "XMLID_728_",
    rx: 13.213,
    ry: 19.633
  }), /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M94.216,92.526h-5.194c-1.104,0-2-0.896-2-2s0.896-2,2-2h5.194c1.104,0,2,0.896,2,2 S95.32,92.526,94.216,92.526z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M94.216,83.937h-5.194c-1.104,0-2-0.896-2-2s0.896-2,2-2h5.194c1.104,0,2,0.896,2,2 S95.32,83.937,94.216,83.937z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M94.216,101.115h-5.194c-1.104,0-2-0.896-2-2s0.896-2,2-2h5.194c1.104,0,2,0.896,2,2 S95.32,101.115,94.216,101.115z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "_x31_0_Cherry"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_9_Sapota"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_8_Custard_Apple"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_7_Watermelon"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_6_Mango"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_5_Pear"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_4_Guava"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_3_Pomegranate"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_2_Orange"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_1_Apple"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.c2a62b584bcf171e2aa517ac4bc648f3.svg";
export { ForwardRef as ReactComponent };